<div>
    <div class="display-container">
        <div class="display-column-label">Name</div>
        <div class="display-column-value">{{customer.fullName}}</div>
    </div>
    <div class="display-container">
        <div class="display-column-label">Customer Type</div>
        <div class="display-column-value">{{customer.customerType}}</div>
    </div>
    <div class="display-container">
        Contacts
    </div>
    @for (contact of customer.contacts; track contact) {  
    <div class="display-container" [ngClass]="{'display-container': true, 'indent': !canSelectContacts}">
        @if (canSelectContacts) {
        <p-checkbox [inputId]="'contact-' + contact.id" name="group" [value]="contact.id" [(ngModel)]="selectedContacts" (onChange)="onChange()">
        </p-checkbox>
        }
        <div class="display-column-label">Name</div>
        <div class="display-column-value">{{contact.fullName}}</div>
    </div>
    <div class="display-container indent">
        <div class="display-column-label">Phone Number</div>
        <div class="display-column-value">{{contact.phone | phoneNumber}}</div>
    </div>
    <div class="display-container indent">
        <div class="display-column-label">Email Address</div>
        <div class="display-column-value">{{contact.email}}</div>
    </div>
    }
</div>